/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { type Meta, type StoryObj } from '@storybook/react-vite';

import { Skeleton } from '../../index';
import {
  SkeletonCircular,
  SkeletonCircularSrc,
  SkeletonDefault,
  SkeletonDefaultSrc,
  SkeletonFullExample,
  SkeletonFullExampleSrc,
  SkeletonInheritHeight,
  SkeletonInheritHeightSrc,
  SkeletonInheritWidth,
  SkeletonInheritWidthSrc,
} from '.';

const componentMeta = {
  title: 'Components/Skeleton',
  id: 'components-skeleton',
  component: Skeleton,
  tags: ['docsPage'],
  parameters: {
    controls: { disable: true },
  },
} satisfies Meta<typeof Skeleton>;

export default componentMeta;
type Story = StoryObj<typeof componentMeta>;

export const Default: Story = {
  args: {
    children: undefined,
    shape: 'rectangular',
    height: undefined,
    width: undefined,
    onBackground: 'default',
    isLoading: true,
  },
  render: SkeletonDefault,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: SkeletonDefaultSrc,
      },
    },
  },
};

export const Circular: Story = {
  args: {
    children: undefined,
    shape: 'circular',
    height: undefined,
    width: undefined,
    onBackground: 'default',
    isLoading: true,
  },
  render: SkeletonCircular,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: SkeletonCircularSrc,
      },
    },
  },
};

export const InheritWidth: Story = {
  args: {
    children: undefined,
    shape: 'rectangular',
    height: undefined,
    width: undefined,
    onBackground: 'default',
    isLoading: true,
  },
  render: SkeletonInheritWidth,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: SkeletonInheritWidthSrc,
      },
    },
  },
};

export const InheritHeight: Story = {
  args: {
    children: undefined,
    shape: 'rectangular',
    height: undefined,
    width: undefined,
    onBackground: 'default',
    isLoading: true,
  },
  render: SkeletonInheritHeight,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: SkeletonInheritHeightSrc,
      },
    },
  },
};

export const FullExample: Story = {
  args: {
    children: undefined,
    shape: 'rectangular',
    height: undefined,
    width: undefined,
    onBackground: 'default',
    isLoading: true,
  },
  render: SkeletonFullExample,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: SkeletonFullExampleSrc,
      },
    },
  },
};
